import { render, staticRenderFns } from "./ButtonConfirmation.vue?vue&type=template&id=b3a2c004&scoped=true&"
import script from "./ButtonConfirmation.vue?vue&type=script&lang=js&"
export * from "./ButtonConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a2c004",
  null
  
)

export default component.exports